import Cookies from "js-cookie";
import { logoutHelper } from "../../utils/helpers";

const useRoles = (roles) => {
    const userRoles = Cookies.get("roles") && JSON.parse(Cookies.get("roles"));
    const isLoggedIn = Cookies.get("token") && Cookies.get("user");
    if (!userRoles) {
        if (isLoggedIn) {
            logoutHelper();
        }
        return false;
    }
    return roles.some(role => userRoles.includes(role));
}

export default useRoles;